import styles from './Review.module.css'
import React, {useEffect, useRef, useState} from "react";
import capImage from '../../Img/capture.png'
import tel from '../../Img/Card/tel_white.png'
import max from '../../Img/Card/max_white.png'
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {text} from "stream/consumers";
import useFormValidator, {FormValidatorInt} from "../../FormValidator/FormValidator";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import {Link} from "react-router-dom";


interface SetReviewCountInt
{
    (cnt:number):void
}

interface FeedBackListInt
{
    author: string;
    parent:number;
    text:string;
    createdAt: string
    id:number
}



interface ReviewPropsInt
{
    tarifId:string
    setReviewCount: SetReviewCountInt
}
interface TopicListInt
{
    author: string;
    date: string;
    text: string;
    reply: TopicListInt[]
}
interface NewTopicInt
{
    tarifId:string
    author:string
    capt:string
    text:string
    eMail?:string
}

interface ListFeedBackInt
{
    tarifId:string
}

interface AddFeedBackInt
{
    author:string;
    text:string;
    type:number;
    parent:number;
    phone?:string;
    eMail?:string;
    xData?:string;
    yData?:string;
    capt:string;
}

export default function Review({tarifId,setReviewCount}:ReviewPropsInt)
{

    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);
    const [addFeedback, setAddFeedback] = useState()

    const listFeedBackData = useRef<ListFeedBackInt>()
    const [ldrListFeedback,rsListFeedback,exListFeedback] = useApiQuery("/appeal/list/tarif","post",listFeedBackData);
    const [listFeedback, setListFeedback] = useState<FeedBackListInt[]>([])

    const [listLength, setListLength] = useState(0)




    const errorLineRef = useRef<ErrorLineItemRef>(null)






    const dataCapt = useRef({
        name: "pAppeal",
        len:4,
        useDigit:true
    })
    const [ldrDataCapt,rsDataItemCapt,executeLoadDataCapt] = useApiQuery("/auth/capt","post",dataCapt);


    const [capt,setCap]=useState("")

    const [acceptPd, setAcceptPd]= useState(false)
    const [formData,setFormData]=useState<FormValidatorInt[]>([
        {
            val:"",
            id:"text",
            errText: "Не верное содержание вопроса",
            regExp: /(\S|(\S\s*)){10,}/ui,
            isCheck: true,
            valid: true
        },
        {
            val:"Гость",
            id:"name",
            errText: "Не корректное имя",
            regExp: /^[a-zа-я]+[a-z0-9-а-я\s-]+$/ui,
            isCheck: true,
            valid: true
        },
        {
            val:"",
            id:"eMail",
            errText: "Не корректный eMail",
            regExp: /(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)|(^$)/ui,
            isCheck: true,
            valid: true
        },
        {
            val:"",
            id:"capt",
            errText: "Не корректный код",
            regExp: /^[a-z0-9]{4,}$/ui,
            isCheck: true,
            valid: true
        },
    ])
    const [validate,validateById,getValue,setValue,getErrText] = useFormValidator(formData)






    const loadNewCapt= ()=>
    {
        executeLoadDataCapt().then((e)=>{
            if(e?.success)setCap(e?.payload)
        })

    }

    useEffect(()=>{
        loadNewCapt()
    },[dataCapt])

    useEffect(()=>{
        if(! tarifId) return;
        listFeedBackData.current = {
            tarifId: tarifId,
        }
        exListFeedback().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                setListFeedback(e?.payload)
                setListLength(e?.payload?.filter((item: FeedBackListInt)=>item?.parent === 0).length)


                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,2000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,2000)
        })

        return

    },[listFeedBackData])

    const buildReply = (reply:number)=>{
        const rp = listFeedback.filter((item)=>item?.parent === reply)

        return rp.map((item,key)=>{
            const date = new Date(item.createdAt).toLocaleDateString()

            return(
                <div className={styles.replyCont} key={key}>
                    <div className={styles.lineTitle}>
                        <span className={styles.lineTitleAuthor}>{item.author}</span>
                        <span className={styles.lineTitleData}>{date}</span>
                    </div>
                    <div className={styles.lineText}>
                        {item.text}
                    </div>

                </div>
            )
        })

    }
    const buildLineList = ()=>{

        const lp = listFeedback.filter((item)=>item?.parent ===0)
        const ls =lp.map((item,key)=>{
            const date = new Date(item?.createdAt).toLocaleDateString()
            return(
                <div key={key} className={styles.rewLineCont}>
                    <div className={styles.lineTitle}>
                        <span className={styles.lineTitleAuthor}>{item.author}</span>
                        <span className={styles.lineTitleData}>{date}</span>
                    </div>
                    <div className={styles.lineText}>
                        {item.text}
                    </div>
                    {buildReply(item.id)}
                </div>
            )

        })
        return ls
    }

    const handleSend=()=>{
        if(!validate())return
        addFeedBackData.current = {
            author:getValue("name"),
            capt:getValue("capt"),
            text: getValue("text"),
            xData: tarifId,
            type: 0,
            parent:0,
            eMail: getValue("eMail").toString().length ? getValue("eMail") : undefined,
        }
        console.log(addFeedBackData.current)
        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show( "Вопрос отправлен, ожидайте модерации",false,5000)
                loadNewCapt()
                setAcceptPd(false)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        })







    }

    return(
        <WaitLoader loading={ldrListFeedback} api={rsListFeedback} onlyLoading={true}>

        <div className={styles.reviewCont}>
            <div className={styles.rewMsgCont}>
                <Link to={"https://max.ru/join/sOT_zaWH8FKeUHF6MgaYpfkGyEHSbE8V01MoWEui_iw"} className={styles.tLink}>
                    <div className={styles.rewMax}>
                        <img className={styles.telPic} src={max}></img>
                        <div>Задать вопрос в макс</div>
                    </div>

                </Link>
                <Link to={"https://t.me/+69SiZ8wPp2NmMDhi"} className={styles.tLink}>
                    <div className={styles.rewTelegram}>
                        <img className={styles.telPic} src={tel}></img>
                        <div>Задать вопрос в телеграм</div>
                    </div>

                </Link>

            </div>
            <div className={styles.rewTitleCont}>
                <span>Вопрос - Ответ{" [" + listLength + "]"}</span>
            </div>
            <div className={styles.rewContentCont}>
                {buildLineList()}
            </div>
            <div className={styles.formCont}>
                <div className={styles.formTitle}>Задать вопрос на сайте</div>
                <div className={styles.formView}>
                    <form>
                        <div className="row g-3 mb-3">
                            <div className="col-md-12">
                                <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Вопрос</label>
                                <textarea className={["form-control form-control-sm", styles.textArea].join(' ')} id="inputEmail4" maxLength={255} rows={6}
                                          value={getValue("text")}
                                          placeholder={"Текст вопроса"}
                                          onBlur={()=>validateById("text")}
                                          onChange={(e)=>setValue("text",e.target.value)}>

                                </textarea>
                                <div  className={["", styles.errMessage].join(' ')}>{getErrText("text")}</div>
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <label htmlFor="inputEmail5" className="form-label col-form-label-sm">Имя</label>
                                <input type="text" className="form-control form-control-sm" id="inputEmail5" placeholder={"Имя"}
                                       value={getValue("name")}
                                       onBlur={()=>validateById("name")}
                                       onChange={(e)=>setValue("name",e.target.value)}>

                                </input>
                                <div  className={["", styles.errMessage].join(' ')}>{getErrText("name")}</div>



                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputPassword4" className="form-label col-form-label-sm">e-Mail [ не обязательно ]</label>
                                <input type="text" className="form-control form-control-sm" id="inputPassword4"
                                    value={getValue("eMail")}
                                    onBlur={()=>validateById("eMail")}
                                       placeholder={"e-Mail"}
                                    onChange={(e)=>setValue("eMail",e.target.value)}>
                                </input>
                                <div  className={["", styles.errMessage].join(' ')}>{getErrText("eMail")}</div>

                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-12 mb-3">
                                    <div className={styles.captContainer}>
                                        <label htmlFor="exampleInputEmail1 m-0" className="form-label">Проверочный код</label>
                                        <i className={['bx bx-refresh',styles.capRef].join(' ')} onClick={()=>{loadNewCapt() }}></i>
                                        <img className={styles.capImg} src={capt} onClick={()=>{loadNewCapt() }}/>
                                    </div>

                                    <input type="text" className="form-control" placeholder={"Код с картинки"}
                                           aria-describedby="emailHelp"
                                           value={getValue("capt")}
                                           onBlur={()=>validateById("capt")}
                                           onChange={(e)=>setValue("capt",e.target.value)}

                                    ></input>
                                    <div  className={["", styles.errMessage].join(' ')}>{getErrText("capt")}</div>
                            </div>

                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-12 ">
                                <div className="form-check" >
                                    <input className="form-check-input" type="checkbox" id="gridCheck" style={{cursor:"pointer",marginTop:"7px"}}
                                           checked={acceptPd}
                                           onChange={()=>setAcceptPd(!acceptPd)}

                                    ></input>
                                    <label className="form-check-label col-form-label-sm" htmlFor="gridCheck" style={{cursor:"pointer",padding:"0"}}>
                                        Даю согласие на обработку данных
                                    </label>
                                </div>
                            </div>

                        </div>
                        <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>

                        <div className={"row my-2"}>
                            <div className="col-12">
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-face" disabled={!acceptPd}
                                            onClick={()=>handleSend()}
                                            onKeyDown={(e)=>{
                                                if(e.key.match(/enter/i))handleSend()
                                            }}
                                    >Отправить</button>
                                    <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true} ><></></WaitLoader>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </WaitLoader>
    )
}
